// extracted by mini-css-extract-plugin
export default {"container":"theme_container__csaYQ","inner":"theme_inner__C2ROe","logoContainer":"theme_logoContainer__8be+s","information":"theme_information__8DFCE"};